




import React, { useState, useEffect, useRef } from 'react';
import Calendar from 'react-calendar';
import Swal from 'sweetalert2';
import Credit from './credit';
import imgzoos from '../model/imgmodel';
import Navbar from '../navbarv2/navbar';
import Footer from '../navbarv2/footer';
import m1 from '../img_ticket/m-1.png';
import fm1 from '../img_ticket/fm-1.png';
import b1 from '../img_ticket/b-1.png';
import g1 from '../img_ticket/g1.png';
import b2 from '../img_ticket/b-2.png';
import g2 from '../img_ticket/g2.png';
import m2 from '../img_ticket/m-2.png';
import fm2 from '../img_ticket/fm-2.png';
import moto from '../img_ticket/c-bg-01.png';
import car from '../img_ticket/c-bg-2-01.png';
import but from '../img_ticket/c-bg-3-01.png';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookie from '../Cookie/Cookie';
import QRCode from 'react-qr-code';
import { formatDate } from '../FormatDate/formatDate';
import { API_ENDPOINT } from '../auth/config';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Outfit:wght@300;400;500;600;700&display=swap');

  .ticket-page {
    min-height: 100vh;
    background: #0a1628;
    color: #f1f5f9;
  }

  /* ── PAGE HEADER ── */
  .ticket-header {
    background: linear-gradient(135deg, #0d1f3c 0%, #0a1628 100%);
    border-bottom: 1px solid rgba(255,255,255,0.07);
    padding: 48px 40px 40px;
  }

  .ticket-header-inner {
    max-width: 1100px;
    margin: 0 auto;
  }

  .ticket-eyebrow {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #22c55e;
    margin-bottom: 8px;
  }

  .ticket-page-title {
    font-size: clamp(1.8rem, 3vw, 2.6rem);
    font-weight: 700;
    color: #f1f5f9;
    margin: 0 0 24px;
  }

  /* ── STEPS INDICATOR ── */
  .ticket-steps {
    display: flex;
    align-items: center;
    gap: 0;
    flex-wrap: wrap;
    gap: 8px;
  }

  .ticket-step {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .step-num {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: 700;
    flex-shrink: 0;
    transition: all 0.3s;
  }

  .step-num.done    { background: #22c55e; color: #fff; }
  .step-num.active  { background: #fff; color: #0a1628; box-shadow: 0 0 0 3px rgba(255,255,255,0.25); }
  .step-num.pending { background: rgba(255,255,255,0.08); color: #64748b; border: 1px solid rgba(255,255,255,0.12); }

  .step-label {
    font-size: 0.82rem;
    font-weight: 500;
    color: #94a3b8;
    white-space: nowrap;
  }

  .step-label.active { color: #f1f5f9; font-weight: 600; }
  .step-label.done   { color: #22c55e; }

  .step-line {
    width: 32px;
    height: 2px;
    background: rgba(255,255,255,0.1);
    border-radius: 2px;
    margin: 0 4px;
  }

  .step-line.done { background: #22c55e; }

  /* ── MAIN LAYOUT ── */
  .ticket-body {
    max-width: 1100px;
    margin: 0 auto;
    padding: 36px 40px 80px;
    display: grid;
    grid-template-columns: 400px 1fr;
    gap: 28px;
    align-items: start;
  }

  @media (max-width: 900px) {
    .ticket-body { grid-template-columns: 1fr; padding: 24px 16px 60px; }
    .ticket-header { padding: 32px 16px 28px; }
  }

  /* ── LEFT PANEL ── */
  .ticket-left {
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: sticky;
    top: 88px;
  }

  /* PANEL CARD */
  .t-card {
    background: #111d35;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 18px;
    overflow: hidden;
  }

  .t-card-header {
    padding: 16px 20px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .t-card-header-icon {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    background: rgba(34,197,94,0.12);
    border: 1px solid rgba(34,197,94,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
  }

  .t-card-title {
    font-size: 0.875rem;
    font-weight: 600;
    color: #e2e8f0;
  }

  .t-card-title span {
    font-size: 0.72rem;
    color: #22c55e;
    background: rgba(34,197,94,0.1);
    padding: 2px 8px;
    border-radius: 100px;
    margin-left: 8px;
    font-weight: 500;
  }

  /* ZOO SELECTOR */
  .zoo-selector-grid {
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .zoo-option {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 11px 14px;
    border-radius: 12px;
    cursor: pointer;
    border: 1.5px solid transparent;
    background: rgba(255,255,255,0.03);
    transition: all 0.15s;
  }

  .zoo-option:hover { background: rgba(255,255,255,0.07); }

  .zoo-option.selected {
    background: rgba(34,197,94,0.1);
    border-color: rgba(34,197,94,0.35);
  }

  .zoo-option-logo {
    width: 36px;
    height: 36px;
    object-fit: contain;
    border-radius: 8px;
    background: rgba(255,255,255,0.92);
    padding: 4px;
    flex-shrink: 0;
  }

  .zoo-option-name {
    font-size: 0.875rem;
    font-weight: 500;
    color: #cbd5e1;
    flex: 1;
  }

  .zoo-option.selected .zoo-option-name { color: #f1f5f9; }

  .zoo-option-check {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1.5px solid rgba(255,255,255,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.65rem;
    color: transparent;
    flex-shrink: 0;
    transition: all 0.15s;
  }

  .zoo-option.selected .zoo-option-check {
    background: #22c55e;
    border-color: #22c55e;
    color: #fff;
  }

  /* CALENDAR */
  .t-calendar-wrap {
    padding: 16px;
  }

  .t-calendar-wrap .react-calendar {
    width: 100% !important;
    background: transparent !important;
    border: none !important;
    color: #e2e8f0 !important;
  }

  .t-calendar-wrap .react-calendar__navigation button {
    color: #f1f5f9 !important;
    background: transparent !important;
    font-size: 0.9rem !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    min-width: 36px !important;
  }

  .t-calendar-wrap .react-calendar__navigation button:hover {
    background: rgba(255,255,255,0.07) !important;
  }

  .t-calendar-wrap .react-calendar__month-view__weekdays {
    color: #64748b !important;
    font-size: 0.72rem !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
  }

  .t-calendar-wrap .react-calendar__month-view__weekdays abbr {
    text-decoration: none !important;
  }

  .t-calendar-wrap .react-calendar__tile {
    background: transparent !important;
    color: #94a3b8 !important;
    border-radius: 8px !important;
    font-size: 0.85rem !important;
    padding: 8px 4px !important;
    transition: all 0.15s !important;
  }

  .t-calendar-wrap .react-calendar__tile:hover:not(:disabled) {
    background: rgba(255,255,255,0.08) !important;
    color: #f1f5f9 !important;
  }

  .t-calendar-wrap .react-calendar__tile--active {
    background: #22c55e !important;
    color: #fff !important;
    font-weight: 700 !important;
    box-shadow: 0 2px 10px rgba(34,197,94,0.4) !important;
  }

  .t-calendar-wrap .react-calendar__tile--now {
    background: rgba(34,197,94,0.12) !important;
    color: #22c55e !important;
    font-weight: 600 !important;
  }

  .t-calendar-wrap .react-calendar__tile:disabled {
    color: #334155 !important;
    cursor: not-allowed !important;
  }

  /* ANNOUNCEMENT */
  .t-announce {
    margin: 0 14px 14px;
    padding: 12px 14px;
    background: rgba(245,158,11,0.1);
    border: 1px solid rgba(245,158,11,0.25);
    border-radius: 10px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 0.825rem;
    color: #fbbf24;
    line-height: 1.5;
  }

  .t-announce-close {
    background: none;
    border: none;
    color: #64748b;
    cursor: pointer;
    margin-left: auto;
    padding: 0;
    font-size: 0.9rem;
    flex-shrink: 0;
    transition: color 0.2s;
  }

  .t-announce-close:hover { color: #f1f5f9; }

  /* INFO BOX */
  .t-info-box {
    margin: 0 14px 14px;
    padding: 12px 14px;
    background: rgba(59,130,246,0.08);
    border: 1px solid rgba(59,130,246,0.2);
    border-radius: 10px;
    font-size: 0.78rem;
    color: #93c5fd;
    line-height: 1.6;
  }

  .t-info-box strong { color: #bfdbfe; }

  /* ── RIGHT PANEL: TICKET LIST ── */
  .ticket-right {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  /* SELECTED ZOO BAR */
  .ticket-zoo-bar {
    background: #111d35;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 16px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
  }

  .ticket-zoo-bar-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .ticket-zoo-bar-logo {
    width: 44px;
    height: 44px;
    object-fit: contain;
    border-radius: 10px;
    background: rgba(255,255,255,0.92);
    padding: 5px;
    border: 1px solid rgba(255,255,255,0.1);
  }

  .ticket-zoo-bar-name {
    font-size: 1rem;
    font-weight: 700;
    color: #f1f5f9;
  }

  .ticket-zoo-bar-date {
    font-size: 0.8rem;
    color: #64748b;
    margin-top: 2px;
  }

  .ticket-zoo-bar-date.selected { color: #22c55e; }

  /* TICKET ITEM */
  .ticket-item {
    background: #ffffff;
    border-radius: 14px;
    padding: 0;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0,0,0,0.25);
    transition: box-shadow 0.2s;
  }

  .ticket-item:hover { box-shadow: 0 4px 20px rgba(0,0,0,0.35); }

  .ticket-item-inner {
    display: flex;
    align-items: center;
    padding: 14px 18px;
    gap: 14px;
  }

  .ticket-item-img {
    width: 56px;
    height: 56px;
    object-fit: contain;
    border-radius: 10px;
    background: #f8fafc;
    padding: 4px;
    border: 1px solid #e2e8f0;
    flex-shrink: 0;
  }

  .ticket-item-info { flex: 1; }

  .ticket-item-name {
    font-size: 0.95rem;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 2px;
  }

  .ticket-item-price {
    font-size: 0.85rem;
    color: #16a34a;
    font-weight: 600;
  }

  /* COUNTER */
  .ticket-counter {
    display: flex;
    align-items: center;
    gap: 0;
    background: #f8fafc;
    border: 1.5px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
  }

  .counter-btn {
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    font-weight: 700;
    color: #334155;
    transition: background 0.15s, color 0.15s;
    user-select: none;
    flex-shrink: 0;
  }

  .counter-btn:hover { background: #e2e8f0; color: #0f172a; }
  .counter-btn.inc:hover { background: #dcfce7; color: #15803d; }
  .counter-btn.dec:hover { background: #fee2e2; color: #b91c1c; }

  .counter-value {
    width: 44px;
    text-align: center;
    font-size: 1rem;
    font-weight: 700;
    color: #0f172a;
    border-left: 1.5px solid #e2e8f0;
    border-right: 1.5px solid #e2e8f0;
    padding: 0 4px;
    height: 36px;
    line-height: 36px;
    background: #fff;
  }

  .ticket-item-subtotal {
    font-size: 0.875rem;
    font-weight: 700;
    color: #0f172a;
    min-width: 64px;
    text-align: right;
    background: #f0fdf4;
    padding: 4px 10px;
    border-radius: 8px;
    border: 1px solid #bbf7d0;
    white-space: nowrap;
  }

  /* EMPTY STATE */
  .ticket-empty {
    background: #111d35;
    border: 1px dashed rgba(255,255,255,0.1);
    border-radius: 16px;
    padding: 48px 24px;
    text-align: center;
  }

  .ticket-empty-icon { font-size: 2.5rem; opacity: 0.4; margin-bottom: 12px; }
  .ticket-empty-text { font-size: 0.9rem; color: #475569; }

  /* ── ORDER SUMMARY ── */
  .order-summary {
    background: #111d35;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 18px;
    overflow: hidden;
    position: sticky;
    bottom: 20px;
  }

  .order-summary-header {
    padding: 16px 20px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    font-size: 0.875rem;
    font-weight: 600;
    color: #e2e8f0;
  }

  .order-summary-rows {
    padding: 14px 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.85rem;
  }

  .summary-row-label { color: #64748b; }
  .summary-row-value { color: #cbd5e1; font-weight: 500; }

  .summary-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 20px;
    background: rgba(34,197,94,0.07);
    border-top: 1px solid rgba(34,197,94,0.15);
  }

  .summary-total-label { font-size: 0.875rem; font-weight: 600; color: #94a3b8; }
  .summary-total-price { font-size: 1.5rem; font-weight: 800; color: #f1f5f9; letter-spacing: -0.02em; }
  .summary-total-price span { font-size: 0.8rem; color: #64748b; font-weight: 400; margin-left: 4px; }

  /* PROCEED BUTTON */
  .proceed-btn {
    margin: 0 16px 16px;
    width: calc(100% - 32px);
    padding: 14px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border: none;
    border-radius: 12px;
    color: #fff;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 4px 16px rgba(34,197,94,0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .proceed-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(34,197,94,0.5);
  }

  .proceed-btn:disabled {
    background: rgba(255,255,255,0.07);
    color: #334155;
    box-shadow: none;
    cursor: not-allowed;
  }

  /* ── PAYMENT SECTION ── */
  .payment-section {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 40px 80px;
  }

  @media (max-width: 900px) {
    .payment-section { padding: 0 16px 60px; }
  }

  .payment-card {
    background: #111d35;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 20px;
    overflow: hidden;
    animation: slideUp 0.3s ease;
  }

  @keyframes slideUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .payment-card-header {
    padding: 24px 28px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .payment-card-title {
    font-size: 1.3rem;
    font-weight: 700;
    color: #f1f5f9;
    margin: 0;
  }

  .payment-card-sub {
    font-size: 0.8rem;
    color: #64748b;
    margin-top: 2px;
  }

  /* ORDER REVIEW in payment */
  .payment-review {
    padding: 20px 28px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
  }

  .payment-review-zoo {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .payment-review-zoo img {
    width: 48px;
    height: 48px;
    object-fit: contain;
    border-radius: 10px;
    background: rgba(255,255,255,0.07);
    padding: 5px;
    border: 1px solid rgba(255,255,255,0.1);
  }

  .payment-review-label {
    font-size: 0.75rem;
    color: #64748b;
    margin-bottom: 2px;
  }

  .payment-review-value {
    font-size: 0.95rem;
    font-weight: 600;
    color: #f1f5f9;
  }

  .payment-total-display {
    text-align: right;
  }

  .payment-total-display .total-label { font-size: 0.75rem; color: #64748b; margin-bottom: 2px; }
  .payment-total-display .total-amount { font-size: 1.8rem; font-weight: 800; color: #f1f5f9; letter-spacing: -0.02em; }
  .payment-total-display .total-currency { font-size: 0.85rem; color: #64748b; margin-left: 4px; }

  /* PAYMENT METHODS */
  .payment-methods {
    padding: 20px 28px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .payment-methods-label {
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #475569;
    margin-bottom: 6px;
  }

  .payment-method-option {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 18px;
    border-radius: 14px;
    border: 1.5px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.03);
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
  }

  .payment-method-option:hover { border-color: rgba(255,255,255,0.18); background: rgba(255,255,255,0.06); }

  .payment-method-option.selected {
    border-color: #22c55e;
    background: rgba(34,197,94,0.07);
  }

  .payment-method-option input[type="radio"] {
    width: 18px;
    height: 18px;
    accent-color: #22c55e;
    cursor: pointer;
    flex-shrink: 0;
  }

  .payment-method-img { width: 64px; height: 36px; object-fit: contain; flex-shrink: 0; }

  .payment-method-info { flex: 1; }
  .payment-method-name { font-size: 0.9rem; font-weight: 600; color: #f1f5f9; }
  .payment-method-desc { font-size: 0.75rem; color: #64748b; margin-top: 2px; }

  .payment-method-badge {
    padding: 3px 10px;
    background: rgba(34,197,94,0.12);
    border: 1px solid rgba(34,197,94,0.25);
    border-radius: 100px;
    font-size: 0.68rem;
    font-weight: 600;
    color: #22c55e;
  }

  /* PAY BUTTON */
  .pay-btn {
    margin: 0 28px 24px;
    padding: 15px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border: none;
    border-radius: 14px;
    color: #fff;
    font-size: 1.05rem;
    font-weight: 700;
    cursor: pointer;
    width: calc(100% - 56px);
    transition: transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 4px 20px rgba(34,197,94,0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .pay-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 32px rgba(34,197,94,0.5);
  }

  .pay-btn:disabled {
    background: rgba(255,255,255,0.07);
    color: #334155;
    box-shadow: none;
    cursor: not-allowed;
  }

  /* SECURITY NOTICE */
  .security-notice {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 28px 20px;
    font-size: 0.75rem;
    color: #475569;
  }

  /* ── MODAL OVERLAY ── */
  .t-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.8);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    animation: fadeIn 0.25s ease;
  }

  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

  .t-modal {
    background: #0f172a;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 20px;
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    animation: slideUp 0.3s ease;
  }

  .t-modal-header {
    padding: 20px 24px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    background: #0f172a;
    z-index: 1;
  }

  .t-modal-title { font-size: 1rem; font-weight: 700; color: #f1f5f9; margin: 0; }
  .t-modal-sub   { font-size: 0.75rem; color: #64748b; margin-top: 2px; }

  .t-modal-close {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: rgba(255,255,255,0.06);
    border: none;
    color: #94a3b8;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    transition: background 0.2s;
    flex-shrink: 0;
  }

  .t-modal-close:hover { background: rgba(248,113,113,0.15); color: #f87171; }

  .t-modal-body { padding: 20px 24px; }

  /* MODAL TICKET SUMMARY */
  .modal-summary-total {
    background: rgba(34,197,94,0.07);
    border: 1px solid rgba(34,197,94,0.2);
    border-radius: 14px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .modal-total-label { font-size: 0.875rem; color: #94a3b8; }
  .modal-total-amount {
    font-size: 1.6rem;
    font-weight: 800;
    color: #f1f5f9;
    letter-spacing: -0.02em;
  }
  .modal-total-amount span { font-size: 0.85rem; color: #64748b; margin-left: 4px; }

  .modal-ticket-list { display: flex; flex-direction: column; gap: 8px; }

  .modal-ticket-row {
    background: #ffffff;
    border-radius: 12px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .modal-ticket-row img {
    width: 44px;
    height: 44px;
    object-fit: contain;
    border-radius: 8px;
    background: #f8fafc;
    padding: 4px;
    border: 1px solid #e2e8f0;
    flex-shrink: 0;
  }

  .modal-ticket-name { font-size: 0.875rem; font-weight: 600; color: #0f172a; }
  .modal-ticket-price { font-size: 0.78rem; color: #64748b; margin-top: 1px; }
  .modal-ticket-qty {
    margin-left: auto;
    background: #f0fdf4;
    border: 1.5px solid #bbf7d0;
    border-radius: 8px;
    padding: 4px 12px;
    font-size: 0.875rem;
    font-weight: 700;
    color: #15803d;
    white-space: nowrap;
  }

  .t-modal-footer {
    padding: 16px 24px;
    border-top: 1px solid rgba(255,255,255,0.07);
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    position: sticky;
    bottom: 0;
    background: #0f172a;
  }

  .t-btn-ghost {
    padding: 10px 20px;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 10px;
    color: #94a3b8;
    font-size: 0.875rem;
    cursor: pointer;
    transition: background 0.2s;
  }

  .t-btn-ghost:hover { background: rgba(255,255,255,0.09); }

  .t-btn-green {
    padding: 10px 24px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border: none;
    border-radius: 10px;
    color: #fff;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(34,197,94,0.3);
    transition: transform 0.15s;
  }

  .t-btn-green:hover { transform: translateY(-1px); }

  /* ══════════════════════════════════════
     MOBILE RESPONSIVE  (max-width: 600px)
     ══════════════════════════════════════ */

  @media (max-width: 600px) {

    /* HEADER */
    .ticket-header { padding: 20px 16px 18px; }
    .ticket-page-title { font-size: 1.4rem; margin-bottom: 14px; }
    .ticket-eyebrow { font-size: 0.65rem; }

    /* STEPS — ซ่อน label ที่ไม่ active */
    .ticket-steps { gap: 6px; }
    .step-label { display: none; }
    .step-label.active { display: block; font-size: 0.75rem; }
    .step-line { width: 20px; }
    .step-num { width: 28px; height: 28px; font-size: 0.72rem; }

    /* BODY GRID */
    .ticket-body { padding: 16px 12px 100px; gap: 16px; }

    /* LEFT PANEL — ไม่ sticky บน mobile */
    .ticket-left { position: static; top: auto; gap: 12px; }

    /* ZOO SELECTOR */
    .zoo-selector-grid { padding: 10px; gap: 4px; }
    .zoo-option { padding: 10px 12px; gap: 10px; }
    .zoo-option-logo { width: 30px; height: 30px; }
    .zoo-option-name { font-size: 0.82rem; }

    /* CALENDAR */
    .t-calendar-wrap { padding: 10px 8px; }
    .t-calendar-wrap .react-calendar__tile { padding: 6px 2px !important; font-size: 0.8rem !important; }
    .t-calendar-wrap .react-calendar__navigation button { font-size: 0.82rem !important; min-width: 30px !important; }

    /* INFO/ANNOUNCE BOXES */
    .t-announce { margin: 0 10px 10px; font-size: 0.78rem; }
    .t-info-box  { margin: 0 10px 10px; font-size: 0.74rem; }

    /* ZOO BAR */
    .ticket-zoo-bar { padding: 12px 14px; }
    .ticket-zoo-bar-logo { width: 36px; height: 36px; }
    .ticket-zoo-bar-name { font-size: 0.9rem; }
    .ticket-zoo-bar-date { font-size: 0.75rem; }

    /* TICKET ITEM — stack image+info / counter / subtotal */
    .ticket-item-inner {
      flex-wrap: wrap;
      padding: 12px 14px;
      gap: 10px;
    }

    .ticket-item-img { width: 48px; height: 48px; }

    .ticket-item-info { flex: 1 1 auto; min-width: 0; }
    .ticket-item-name { font-size: 0.875rem; }
    .ticket-item-price { font-size: 0.8rem; }

    /* Counter & subtotal ย้ายมาอยู่แถวเดียวกันด้านล่าง */
    .ticket-counter {
      order: 10;
      flex: 0 0 auto;
    }
    .counter-btn  { width: 40px; height: 40px; font-size: 1.1rem; }
    .counter-value { width: 40px; height: 40px; line-height: 40px; font-size: 1rem; }

    .ticket-item-subtotal {
      order: 10;
      flex: 1 1 auto;
      text-align: center;
      font-size: 0.95rem;
    }

    /* ORDER SUMMARY */
    .order-summary { position: static; }
    .summary-total-price { font-size: 1.3rem; }

    /* PROCEED BUTTON */
    .proceed-btn {
      margin: 0 12px 14px;
      width: calc(100% - 24px);
      padding: 16px;
      font-size: 0.95rem;
      /* ปุ่ม sticky ที่ด้านล่างจอ */
      position: sticky;
      bottom: 12px;
      z-index: 100;
      box-shadow: 0 8px 32px rgba(34,197,94,0.45);
    }

    /* PAYMENT CARD */
    .payment-card-header { padding: 18px 16px; }
    .payment-card-title  { font-size: 1.1rem; }

    .payment-review { padding: 16px; flex-direction: column; align-items: flex-start; gap: 14px; }
    .payment-total-display { text-align: left; width: 100%; }
    .payment-total-display .total-amount { font-size: 1.5rem; }

    .payment-methods { padding: 14px 16px; }
    .payment-method-option { padding: 14px; gap: 12px; }
    .payment-method-img  { width: 52px; height: 30px; }
    .payment-method-name { font-size: 0.85rem; }
    .payment-method-desc { font-size: 0.7rem; }

    /* PAY BUTTON */
    .pay-btn {
      margin: 0 16px 20px;
      width: calc(100% - 32px);
      padding: 17px;
      font-size: 1rem;
    }

    /* MODAL */
    .t-modal { border-radius: 16px 16px 0 0; max-height: 92vh; }
    .t-modal-overlay { align-items: flex-end; padding: 0; }
    .t-modal-header { padding: 16px 18px; }
    .t-modal-body   { padding: 16px 18px; }
    .t-modal-footer {
      padding: 14px 18px;
      flex-direction: column-reverse;
      gap: 8px;
    }
    .t-btn-ghost, .t-btn-green {
      width: 100%;
      padding: 13px;
      text-align: center;
      font-size: 0.9rem;
    }

    /* MODAL TICKET ROW */
    .modal-ticket-row { padding: 10px 12px; gap: 10px; }
    .modal-ticket-row img { width: 38px; height: 38px; }
    .modal-ticket-name  { font-size: 0.82rem; }
    .modal-ticket-price { font-size: 0.72rem; }
    .modal-ticket-qty   { font-size: 0.82rem; padding: 3px 10px; }

    .modal-summary-total { padding: 14px 16px; }
    .modal-total-amount  { font-size: 1.3rem; }
  }

  /* ── SMALL TABLET (601–900px) ── */
  @media (min-width: 601px) and (max-width: 900px) {
    .ticket-left { position: static; }
    .ticket-body { gap: 20px; }
    .ticket-item-inner { padding: 12px 16px; }
    .counter-btn  { width: 38px; height: 38px; }
    .counter-value { width: 40px; height: 38px; line-height: 38px; }
    .payment-review { flex-direction: column; align-items: flex-start; }
    .payment-total-display { text-align: left; }
    .t-modal-overlay { align-items: flex-end; padding: 0; }
    .t-modal { border-radius: 16px 16px 0 0; }
  }
`;

/* ───── helpers ───── */
const getImageUrl = (ticketName, fallback) => {
  if (ticketName.includes('ผู้ใหญ่ ชาย')) return m1;
  if (ticketName.includes('ผู้ใหญ่ หญิง')) return fm1;
  if (ticketName.includes('เด็ก ชาย')) return b1;
  if (ticketName.includes('เด็ก หญิง')) return g1;
  if (ticketName.includes('Adult Male')) return m2;
  if (ticketName.includes('Adult Female')) return fm2;
  if (ticketName.includes('Child Male')) return b2;
  if (ticketName.includes('Child Female')) return g2;
  if (ticketName.includes('รถจักรยานยนต์')) return moto;
  if (ticketName.includes('รถยนต์')) return car;
  if (ticketName.includes('รถบัส')) return but;
  return fallback;
};

const formatTime = (seconds) => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s < 10 ? '0' : ''}${s}`;
};

/* ─────────────────────────────────── COMPONENT ─────────────────────────────────── */
function Addticket() {
  const [Ticket, setTicket] = useState([]);
  const [selectedTickets, setselectedTickets] = useState([]);
  const [date, setDate] = useState('');
  const [createdAt, setCreatedAt] = useState(new Date());
  const [qrData, setqrData] = useState('');
  const [Ref, setRef1] = useState('');
  const [Ref2, setRef2] = useState('');
  const [idOrder, setidOrder] = useState('');
  const [ticketCounts, setTicketCounts] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [selectedId, setSelectedId] = useState(null);
  const [idzoo, setIdzood] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [name, setname] = useState(null);
  const [Payment, setPayment] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [ShowAnnounce, setShowAnnounce] = useState(false);
  const [Announcetext, setAnnouncetext] = useState('');
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const paymentSectionRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const iduser = localStorage.getItem('userid');

  /* ── STEP CALC ── */
  const step = !idzoo ? 1 : !date ? 2 : selectedTickets.length === 0 ? 3 : Payment === 1 ? 4 : 3;

  /* ── DATE LOGIC ── */
  const onChange = (newDate) => {
    const currentDate = new Date();
    const limitTime = new Date(currentDate);
    limitTime.setHours(14, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
    newDate.setHours(0, 0, 0, 0);

    const diffDays = (newDate - currentDate) / (1000 * 60 * 60 * 24);

    if (diffDays > 90) {
      const yearBE = new Date().getFullYear() + 543;  // ปี พ.ศ. ปัจจุบัน
      Swal.fire({
        icon: 'info', title: `📌 เงื่อนไขการจองล่วงหน้า`,
        html: `<div style="text-align:left;font-family:'Outfit',sans-serif">
          <p>✅ เลือกวันได้ <b>ไม่เกิน 90 วัน</b> นับจากวันที่ซื้อ</p>
          <p>✅ เลื่อนวันได้ <b>1 ครั้ง</b> ภายใน 90 วัน</p>
          <p>📞 หากมีข้อสงสัย กรุณาติดต่อผู้ดูแลระบบ</p></div>`,
        confirmButtonText: 'เข้าใจแล้ว', confirmButtonColor: '#22c55e', width: 480
      });
      return;
    }

    const endOfPeriod = new Date(currentDate.getFullYear(), 8, 30);
    if (currentDate.getMonth() < 9 && newDate > endOfPeriod) {
      Swal.fire({
        icon: 'info', title: '📌 เงื่อนไขการจอง',
        html: `<div style="text-align:left;font-family:'Outfit',sans-serif">
          <p>วันที่เลือกต้องไม่เกิน <b>30 กันยายน ${currentDate.getFullYear() + 543}</b></p>
          <p>หากต้องการจองหลังจากนั้น กรุณาทำรายการใหม่ตั้งแต่ <b>1 ตุลาคม</b> เป็นต้นไป</p></div>`,
        confirmButtonText: 'เข้าใจแล้ว', confirmButtonColor: '#22c55e', width: 480
      });
      return;
    }

    if (newDate > currentDate) {
      const y = newDate.getFullYear();
      const m = String(newDate.getMonth() + 1).padStart(2, '0');
      const d = String(newDate.getDate()).padStart(2, '0');
      setDate(`${y}-${m}-${d}`);
      setPayment(0);
    } else if (newDate.getTime() === currentDate.getTime() && new Date() <= limitTime) {
      const y = newDate.getFullYear();
      const m = String(newDate.getMonth() + 1).padStart(2, '0');
      const d = String(newDate.getDate()).padStart(2, '0');
      setDate(`${y}-${m}-${d}`);
      setPayment(0);
    } else {
      Swal.fire({
        icon: 'warning', title: 'หมดเวลาจองวันนี้',
        html: `<div style="font-family:'Outfit',sans-serif">
          <p>รับจองถึงเวลา <b>14:00 น.</b> ของวันเท่านั้น</p>
          <p>กรุณาเลือกวันพรุ่งนี้หรือวันในอนาคต</p></div>`,
        confirmButtonText: 'ตกลง', confirmButtonColor: '#ef4444', width: 400
      });
    }
  };

  /* ── COUNTER ── */
  const decreaseCount = (id) => {
    setPayment(0);
    setSelectedPaymentMethod('');
    setTicketCounts(prev => {
      const updated = { ...prev };
      if (updated[id] > 0) updated[id]--;
      return updated;
    });
  };

  const increaseCount = (id) => {
    setPayment(0);
    setSelectedPaymentMethod('');
    if (!date) {
      Swal.fire({ icon: 'warning', title: 'กรุณาเลือกวันที่ก่อน', confirmButtonColor: '#22c55e', width: 380 });
      return;
    }
    setTicketCounts(prev => ({ ...prev, [id]: (prev[id] || 0) + 1 }));
  };

  /* ── EFFECTS ── */
  useEffect(() => {
    const sel = Ticket.filter(t => ticketCounts[t.id] > 0);
    const total = sel.reduce((acc, t) => acc + ticketCounts[t.id] * t.price, 0);
    setTotalPrice(total);
    setselectedTickets(sel);
  }, [ticketCounts, Ticket]);

  useEffect(() => {
    // Announce
    fetch("https://www.addpay.co.th/service-ui/service-my-zoo-admin/announce.php")
      .then(r => r.json())
      .then(result => {
        if (result.status === true) {
          const hideDate = new Date(result.data.announce_date);
          if (new Date() <= hideDate) {
            setShowAnnounce(true);
            setAnnouncetext(result.data.message);
          }
        }
      }).catch(() => { });
  }, []);

  useEffect(() => {
    const defaultId = state?.id || localStorage.getItem('selectedId');
    if (defaultId) {
      setIdzood(defaultId);
      const found = imgzoos.find(z => z.id === defaultId || z.id === parseInt(defaultId));
      if (found) { setImageUrl(found.img); setname(found.name); setSelectedId(found.id); }
      fetchTickets(defaultId);
    }
  }, []);

  useEffect(() => {
    if (selectedId) {
      localStorage.setItem('selectedId', selectedId);
      setIdzood(selectedId);
      fetchTickets(selectedId);
    }
  }, [selectedId]);

  /* ── FETCH TICKETS ── */
  const fetchTickets = async (id) => {
    if (!id) return;
    const myHeaders = new Headers();
    myHeaders.append("X-API-KEY", localStorage.getItem('apikey'));
    try {
      const res = await fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/ticket-zoo/${id}`, { method: 'GET', headers: myHeaders, redirect: 'follow' });
      const result = await res.json();
      setTicket(result);
      setTicketCounts({});
    } catch (e) { console.error(e); }
  };

  /* ── SELECT ZOO ── */
  const handleSelect = (id, img, nm) => {
    setSelectedId(id);
    setImageUrl(img);
    setname(nm);
    setDate('');
    setPayment(0);
    setTicketCounts({});
  };

  /* ── SAVE & ORDER ── */
  const saveSelectedTickets = (payment_method) => {
    if (selectedTickets.length === 0) return;
    setIsLoading(true);

    const payload = {
      tickets: selectedTickets.map(t => ({ id: t.id, name: t.name, price: t.price, amount: ticketCounts[t.id] })),
      zoo_id: idzoo, amount: totalPrice, member: iduser, onDate: date,
      payment_method, line_token: localStorage.getItem('token')
    };

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-API-KEY", localStorage.getItem('apikey'));

    fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/onlinePayment`, {
      method: "POST", headers: myHeaders, body: JSON.stringify(payload), redirect: "follow"
    })
      .then(res => {
        if (res.status === 401 || res.status === 500) {
          Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'พบปัญหาระหว่างตรวจสอบผู้ใช้งาน กรุณาออกจากระบบและเข้าระบบอีกครั้ง', confirmButtonText: 'ตกลง', confirmButtonColor: '#ef4444' })
            .then(() => navigate('/home'));
          Error_log();
          return Promise.reject();
        }
        return res.json();
      })
      .then(result => {
        if (result?.error) {
          Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: result.error, confirmButtonText: 'ตกลง', confirmButtonColor: '#ef4444' });
        } else {
          setidOrder(result.id);
          setqrData(result.order?.tqrc_qr);
          setRef1(result.order?.ref1);
          setRef2(result.order?.ref2);
          setCreatedAt(result.order?.created_at);
        }
      })
      .catch(err => {
        if (err) {
          Error_log();
          Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถเชื่อมต่อได้ กรุณาลองใหม่', confirmButtonText: 'ตกลง', confirmButtonColor: '#ef4444' });
        }
      })
      .finally(() => setIsLoading(false));
  };

  const Error_log = () => {
    fetch(`https://addpaycrypto.com/zoo/api-log/?service=sen_logzooticket&status=error-log&token=Ufb3497e10fa1091a93c3d531ecd197f2&messages=จากระบบ Webzoo&api=${API_ENDPOINT}/api/v1/zoo/e-member/onlinePayment`)
      .catch(() => { });
  };

  const handlePaymentChange = (method) => {
    setSelectedPaymentMethod(method);
    saveSelectedTickets(method);
  };

  const option_payment = () => {
    if (selectedTickets.length === 0) return;
    setPayment(1);
    setTimeout(() => paymentSectionRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
  };

  const handleSubmit = () => {
    if (selectedPaymentMethod === 'qrcode') {
      navigate('/Promptpay', { state: { qrData, ref: Ref, ref2: Ref2, total: totalPrice, createdAt, idOrder, date, idzoo } });
    } else {
      navigate('/Payment', { state: { qrData, ref: Ref, ref2: Ref2, total: totalPrice, createdAt, idOrder } });
    }
  };

  /* ── STEPS DATA ── */
  const steps = [
    { num: 1, label: 'เลือกสวนสัตว์', done: !!idzoo },
    { num: 2, label: 'เลือกวันที่', done: !!date },
    { num: 3, label: 'เลือกบัตร', done: selectedTickets.length > 0 },
    { num: 4, label: 'ชำระเงิน', done: false },
  ];

  const currentStep = steps.findIndex(s => !s.done) + 1 || 4;

  return (
    <>
      <style>{styles}</style>
      <div className="ticket-page">
        <Navbar />
        <Cookie />

        {/* PAGE HEADER */}
        <div className="ticket-header">
          <div className="ticket-header-inner">
            <div className="ticket-eyebrow">Zoo e-Ticket</div>
            <h1 className="ticket-page-title">จองตั๋วสวนสัตว์</h1>

            {/* STEPS */}
            <div className="ticket-steps">
              {steps.map((s, i) => (
                <React.Fragment key={s.num}>
                  <div className="ticket-step">
                    <div className={`step-num ${s.done ? 'done' : currentStep === s.num ? 'active' : 'pending'}`}>
                      {s.done ? '✓' : s.num}
                    </div>
                    <span className={`step-label ${s.done ? 'done' : currentStep === s.num ? 'active' : ''}`}>{s.label}</span>
                  </div>
                  {i < steps.length - 1 && <div className={`step-line${s.done ? ' done' : ''}`} />}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
        {/* EXEMPTION INFO */}
        {/* <div className="t-info-box" style={{ margin: '0' }}>
              <strong>ได้รับการยกเว้นค่าบัตร (ชาวไทยเท่านั้น):</strong><br />
              เด็กอายุต่ำกว่า 3 ปี · ผู้สูงอายุ 60 ปีขึ้นไป · พระสงฆ์ · ทหารผ่านศึก · ผู้พิการ<br />
              <span style={{color:'#fbbf24'}}>→ ไม่ต้องเลือกซื้อบัตร แจ้งพนักงานหน้างานได้เลย</span>
            </div> */}


        {/* EXEMPTION INFO */}
        <div style={{
          margin: '20px 0',
          padding: '18px 20px',
          borderRadius: 16,
          background: 'linear-gradient(135deg, #78350f, #92400e)',
          border: '1px solid #fbbf24',
          boxShadow: '0 0 0 4px rgba(251,191,36,.12), 0 8px 24px rgba(0,0,0,.3)',
          position: 'relative',
          overflow: 'hidden',
        }}>
          {/* shimmer bar */}
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, height: 3,
            background: 'linear-gradient(90deg, transparent, #fbbf24, transparent)',
            animation: 'shimmerBar 2s ease-in-out infinite',
          }} />

          {/* icon + title */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
            <span style={{ fontSize: 22 }}>🎫</span>
            <strong style={{
              fontFamily: "'Prompt', sans-serif",
              fontSize: 15, color: '#fde68a', letterSpacing: '.02em',
            }}>
              ได้รับการยกเว้นค่าบัตร
              <span style={{ fontSize: 11, fontWeight: 400, color: 'rgba(253,230,138,.6)', marginLeft: 8 }}>
                (ชาวไทยเท่านั้น)
              </span>
            </strong>
          </div>

          {/* exemption list */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 10px', marginBottom: 12 }}>
            {['👶 เด็กอายุต่ำกว่า 3 ปี', '👴 ผู้สูงอายุ 60 ปีขึ้นไป', '🧡 พระสงฆ์', '🎖 ทหารผ่านศึก', '♿ ผู้พิการ'].map(item => (
              <span key={item} style={{
                background: 'rgba(251,191,36,.15)',
                border: '1px solid rgba(251,191,36,.3)',
                borderRadius: 100,
                padding: '3px 12px',
                fontSize: 13, color: '#fde68a',
              }}>{item}</span>
            ))}
          </div>

          {/* note */}
          <div style={{
            display: 'flex', alignItems: 'center', gap: 8,
            background: 'rgba(0,0,0,.2)', borderRadius: 10,
            padding: '8px 14px',
          }}>
            <span style={{ fontSize: 16 }}>💬</span>
            <span style={{ fontSize: 13, color: '#fbbf24', fontWeight: 600 }}>
              ไม่ต้องเลือกซื้อบัตร — แจ้งพนักงานหน้างานได้เลย
            </span>
          </div>
        </div>

        {/* MAIN BODY */}
        <div className="ticket-body">

          {/* LEFT: ZOO + CALENDAR */}
          <div className="ticket-left">

            {/* ZOO SELECTOR */}
            <div className="t-card">
              <div className="t-card-header">
                <div className="t-card-header-icon">🏛</div>
                <div className="t-card-title">
                  เลือกสวนสัตว์
                  {idzoo && <span>✓ เลือกแล้ว</span>}
                </div>
              </div>
              <div className="zoo-selector-grid">
                {imgzoos.map(zoo => (
                  <div
                    key={zoo.id}
                    className={`zoo-option${selectedId === zoo.id ? ' selected' : ''}`}
                    onClick={() => handleSelect(zoo.id, zoo.img, zoo.name)}
                  >
                    <img src={zoo.img} alt={zoo.name} className="zoo-option-logo" />
                    <span className="zoo-option-name">{zoo.name}</span>
                    <div className="zoo-option-check">✓</div>
                  </div>
                ))}
              </div>
            </div>



            {/* CALENDAR */}
            <div className="t-card">
              <div className="t-card-header">
                <div className="t-card-header-icon">📅</div>
                <div className="t-card-title">
                  เลือกวันที่เข้าชม
                  {date && <span>✓ {formatDate(date)}</span>}
                </div>
              </div>

              {/* ANNOUNCE */}
              {ShowAnnounce && (
                <div className="t-announce">
                  <span>📢</span>
                  <span>{Announcetext}</span>
                  <button className="t-announce-close" onClick={() => setShowAnnounce(false)}>✕</button>
                </div>
              )}

              {/* INFO */}
              <div className="t-info-box" style={{ margin: '0 14px 12px' }}>
                🕐 รับจองถึง <strong>14:00 น.</strong> ของแต่ละวัน &nbsp;|&nbsp;
                📅 จองล่วงหน้าได้สูงสุด <strong>90 วัน</strong>
              </div>

              <div className="t-calendar-wrap">
                <Calendar onChange={onChange} value={date ? new Date(date) : new Date()} />
              </div>
            </div>



          </div>

          {/* RIGHT: TICKETS + SUMMARY */}
          <div className="ticket-right">

            {/* ZOO BAR */}
            <div className="ticket-zoo-bar">
              <div className="ticket-zoo-bar-left">
                {imageUrl
                  ? <img src={imageUrl} alt={name} className="ticket-zoo-bar-logo" />
                  : <div style={{ width: 44, height: 44, borderRadius: 10, background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem' }}>🏛</div>
                }
                <div>
                  <div className="ticket-zoo-bar-name">{name || 'กรุณาเลือกสวนสัตว์'}</div>
                  <div className={`ticket-zoo-bar-date${date ? ' selected' : ''}`}>
                    {date ? `📅 ${formatDate(date)}` : 'กรุณาเลือกวันที่'}
                  </div>
                </div>
              </div>
              {selectedTickets.length > 0 && (
                <button className="t-btn-green" onClick={() => setShowSummaryModal(true)}>
                  ดูรายการ ({selectedTickets.length})
                </button>
              )}
            </div>

            {/* TICKET LIST */}
            {!idzoo ? (
              <div className="ticket-empty">
                <div className="ticket-empty-icon">🏛</div>
                <div className="ticket-empty-text">กรุณาเลือกสวนสัตว์ก่อน</div>
              </div>
            ) : Ticket.length === 0 ? (
              <div className="ticket-empty">
                <div className="ticket-empty-icon">⏳</div>
                <div className="ticket-empty-text">กำลังโหลดข้อมูลบัตร...</div>
              </div>
            ) : (
              Ticket.map(t => {
                const count = ticketCounts[t.id] || 0;
                const subtotal = count * t.price;
                return (
                  <div key={t.id} className="ticket-item">
                    <div className="ticket-item-inner">
                      <img src={getImageUrl(t.name, imageUrl)} alt={t.name} className="ticket-item-img" />
                      <div className="ticket-item-info">
                        <div className="ticket-item-name">{t.name}</div>
                        <div className="ticket-item-price">฿{t.price.toLocaleString()} / ใบ</div>
                      </div>
                      <div className="ticket-counter">
                        <button className="counter-btn dec" onClick={() => decreaseCount(t.id)}>−</button>
                        <div className="counter-value">{count}</div>
                        <button className="counter-btn inc" onClick={() => increaseCount(t.id)}>+</button>
                      </div>
                      <div className={`ticket-item-subtotal${count === 0 ? '' : ''}`} style={count === 0 ? { opacity: 0.3 } : {}}>
                        {count === 0 ? '—' : `฿${subtotal.toLocaleString()}`}
                      </div>
                    </div>
                  </div>
                );
              })
            )}

            {/* ORDER SUMMARY */}
            {idzoo && (
              <div className="order-summary">
                <div className="order-summary-header">สรุปรายการ</div>
                <div className="order-summary-rows">
                  {selectedTickets.length === 0 ? (
                    <div style={{ color: '#475569', fontSize: '0.85rem', textAlign: 'center', padding: '8px 0' }}>
                      ยังไม่มีรายการที่เลือก
                    </div>
                  ) : (
                    selectedTickets.map(t => (
                      <div key={t.id} className="summary-row">
                        <span className="summary-row-label">{t.name} × {ticketCounts[t.id]}</span>
                        <span className="summary-row-value">฿{(t.price * ticketCounts[t.id]).toLocaleString()}</span>
                      </div>
                    ))
                  )}
                </div>
                <div className="summary-total">
                  <span className="summary-total-label">ยอดรวมทั้งหมด</span>
                  <div className="summary-total-price">
                    ฿{totalPrice.toLocaleString()}
                    <span>บาท</span>
                  </div>
                </div>
                <button
                  className="proceed-btn"
                  disabled={selectedTickets.length === 0 || !date}
                  onClick={option_payment}
                >
                  {selectedTickets.length === 0 ? 'เลือกบัตรก่อนดำเนินการ' : !date ? 'เลือกวันที่ก่อนดำเนินการ' : `ดำเนินการชำระเงิน → ฿${totalPrice.toLocaleString()}`}
                </button>
              </div>
            )}

          </div>
        </div>

        {/* PAYMENT SECTION */}
        <div ref={paymentSectionRef} className="payment-section">
          {Payment === 1 && (
            <div className="payment-card">
              <div className="payment-card-header">
                <div style={{ flex: 1 }}>
                  <h2 className="payment-card-title">เลือกช่องทางชำระเงิน</h2>
                  <div className="payment-card-sub">กรุณาเลือกวิธีการชำระที่ต้องการ</div>
                </div>
              </div>

              {/* ORDER REVIEW */}
              <div className="payment-review">
                <div className="payment-review-zoo">
                  {imageUrl && <img src={imageUrl} alt={name} />}
                  <div>
                    <div className="payment-review-label">สวนสัตว์</div>
                    <div className="payment-review-value">{name}</div>
                    <div className="payment-review-label" style={{ marginTop: 6 }}>วันที่เข้าชม</div>
                    <div className="payment-review-value">{date ? formatDate(date) : '-'}</div>
                  </div>
                </div>
                <div className="payment-total-display">
                  <div className="total-label">ยอดชำระทั้งหมด</div>
                  <div className="total-amount">
                    ฿{totalPrice.toLocaleString()}
                    <span className="total-currency">บาท</span>
                  </div>
                </div>
              </div>

              {/* PAYMENT METHODS */}
              <div className="payment-methods">
                <div className="payment-methods-label">วิธีการชำระเงิน</div>

                {/* PROMPTPAY */}
                <div
                  className={`payment-method-option${selectedPaymentMethod === 'qrcode' ? ' selected' : ''}`}
                  onClick={() => handlePaymentChange('qrcode')}
                >
                  <input type="radio" name="paymentMethod" value="qrcode" checked={selectedPaymentMethod === 'qrcode'} onChange={() => { }} />
                  <img src="https://secure1.zimple.cloud/images/thai_qr_payment.png" alt="PromptPay" className="payment-method-img" />
                  <div className="payment-method-info">
                    <div className="payment-method-name">PromptPay / QR Code</div>
                    <div className="payment-method-desc">สแกน QR Code ผ่านแอปธนาคารใดก็ได้</div>
                  </div>
                  <span className="payment-method-badge">แนะนำ</span>
                </div>

                {/* CREDIT CARD */}
                <div
                  className={`payment-method-option${selectedPaymentMethod === 'credit' ? ' selected' : ''}`}
                  onClick={() => handlePaymentChange('credit')}
                >
                  <input type="radio" name="paymentMethod" value="credit" checked={selectedPaymentMethod === 'credit'} onChange={() => { }} />
                  <img src="https://i.imgur.com/sB4jftM.png" alt="Credit Card" className="payment-method-img" />
                  <div className="payment-method-info">
                    <div className="payment-method-name">บัตรเครดิต / เดบิต</div>
                    <div className="payment-method-desc">Visa, Mastercard, JCB</div>
                  </div>
                </div>
              </div>

              {/* PAY BUTTON */}
              <button
                className="pay-btn"
                disabled={!selectedPaymentMethod || isLoading}
                onClick={handleSubmit}
              >
                {isLoading ? '⏳ กำลังดำเนินการ...' : selectedPaymentMethod ? `ชำระเงิน ฿${totalPrice.toLocaleString()}` : 'กรุณาเลือกช่องทางชำระเงิน'}
              </button>

              {/* SECURITY */}
              <div className="security-notice">
                🔒 ข้อมูลของคุณถูกเข้ารหัสและปลอดภัยด้วยมาตรฐาน SSL
              </div>
            </div>
          )}
        </div>

        {/* SUMMARY MODAL */}
        {showSummaryModal && (
          <div className="t-modal-overlay" onClick={() => setShowSummaryModal(false)}>
            <div className="t-modal" onClick={e => e.stopPropagation()}>
              <div className="t-modal-header">
                <div>
                  <h5 className="t-modal-title">รายการบัตรที่เลือก</h5>
                  <div className="t-modal-sub">วันที่เข้าชม: {date ? formatDate(date) : '-'}</div>
                </div>
                <button className="t-modal-close" onClick={() => setShowSummaryModal(false)}>✕</button>
              </div>
              <div className="t-modal-body">
                {/* TOTAL */}
                <div className="modal-summary-total">
                  <span className="modal-total-label">ยอดรวมทั้งหมด</span>
                  <div className="modal-total-amount">
                    ฿{totalPrice.toLocaleString()}
                    <span>บาท</span>
                  </div>
                </div>

                {/* TICKET ROWS */}
                <div className="modal-ticket-list">
                  {selectedTickets.map(t => (
                    <div key={t.id} className="modal-ticket-row">
                      <img src={getImageUrl(t.name, imageUrl)} alt={t.name} />
                      <div>
                        <div className="modal-ticket-name">{t.name}</div>
                        <div className="modal-ticket-price">฿{t.price.toLocaleString()} × {ticketCounts[t.id]} ใบ</div>
                      </div>
                      <div className="modal-ticket-qty">฿{(t.price * ticketCounts[t.id]).toLocaleString()}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="t-modal-footer">
                <button className="t-btn-ghost" onClick={() => setShowSummaryModal(false)}>ปิด</button>
                <button className="t-btn-green" onClick={() => { setShowSummaryModal(false); option_payment(); }}>
                  ดำเนินการชำระเงิน →
                </button>
              </div>
            </div>
          </div>
        )}

        <Footer />
      </div>
    </>
  );
}

export default Addticket;